import { supabase } from './supabase';

/**
 * Devuelve el plan actual del usuario logueado (lee company_profiles.plan).
 * Si algo falla, devuelve null (defensivo: tratamos como "sin plan").
 */
export async function getUserPlan(): Promise<string | null> {
  try {
    const {
      data: { user },
    } = await supabase.auth.getUser();
    if (!user) return null;

    const { data: profile } = await supabase
      .from('profiles')
      .select('id_company')
      .eq('id', user.id)
      .single();
    if (!(profile as any)?.id_company) return null;

    const { data: company } = await supabase
      .from('company_profiles')
      .select('plan')
      .eq('id_company', (profile as any).id_company)
      .single();
    return ((company as any)?.plan as string | null) ?? null;
  } catch {
    return null;
  }
}

// Si se puede sumar una marca ya no lo dice el plan solo (`planAllowsMultiBrand`, "cualquier
// plan pago"): depende de cuántas tiene y del tope del plan. Ver `lib/lugarParaMarcas.ts`
// (ADR-2026-10-27-planes-de-equipo-en-el-front).
